import React from 'react';
import {
  Drawer,
  FormControl,
  InputLabel,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Select,
  Typography,
  Box,
  Toolbar,
  Button,
} from '@mui/material';
import { Link } from 'react-router-dom';
import LogoutIcon from '@mui/icons-material/Logout';
import { useTranslation } from 'react-i18next';

export const drawerWidth = 240;

const Sidebar = ({
  menuItems,
  mobileOpen,
  onMobileClose,
  userEmail,
  organisationName,
  memberships = [],
  activeOrganisationId,
  switchingOrganisation,
  onSwitchOrganisation,
  onLogout,
}) => {
  const { t, i18n } = useTranslation();
  const drawerContent = (
    <Box sx={{ overflow: 'auto' }}>
      <Toolbar sx={{ display: 'block', py: 2 }}>
        <Typography variant="h6" noWrap component="div" sx={{ mb: 1 }}>
          {t('app.name')}
        </Typography>
        <FormControl size="small" fullWidth>
          <InputLabel id="sidebar-language-select-label">{t('app.language')}</InputLabel>
          <Select
            labelId="sidebar-language-select-label"
            label={t('app.language')}
            value={i18n.language}
            onChange={(event) => i18n.changeLanguage(event.target.value)}
          >
            <MenuItem value="en">🇬🇧 English</MenuItem>
            <MenuItem value="hr">🇭🇷 Hrvatski</MenuItem>
          </Select>
        </FormControl>
      </Toolbar>
      <List>
        {menuItems.map((item) => (
          <ListItemButton
            key={item.label}
            component={Link}
            to={item.path}
            onClick={onMobileClose}
          >
            <ListItemIcon>{item.icon}</ListItemIcon>
            <ListItemText primary={item.label} />
          </ListItemButton>
        ))}
      </List>
      <Box sx={{ px: 2, pb: 2 }}>
        {memberships.length > 1 || (memberships.length === 1 && memberships[0].organisationId !== activeOrganisationId) ? (
          <FormControl size="small" fullWidth sx={{ mb: 1 }} disabled={switchingOrganisation}>
            <InputLabel id="sidebar-organisation-select-label">{t('app.activeOrganisation')}</InputLabel>
            <Select
              labelId="sidebar-organisation-select-label"
              label={t('app.activeOrganisation')}
              value={memberships.some((membership) => membership.organisationId === activeOrganisationId)
                ? String(activeOrganisationId)
                : ''}
              onChange={(event) => onSwitchOrganisation(Number(event.target.value))}
            >
              {memberships.map((membership) => (
                <MenuItem key={membership.organisationId} value={String(membership.organisationId)}>
                  {membership.organisationName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        ) : organisationName ? (
          <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
            {organisationName}
          </Typography>
        ) : null}
        {userEmail ? (
          <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
            {userEmail}
          </Typography>
        ) : null}
        <Button
          fullWidth
          variant="outlined"
          startIcon={<LogoutIcon />}
          onClick={onLogout}
        >
          {t('auth.signOut')}
        </Button>
      </Box>
    </Box>
  );

  return (
    <Box
      component="nav"
      sx={{ width: { md: drawerWidth }, flexShrink: { md: 0 } }}
      aria-label={t('app.navigationMenu')}
    >
      <Drawer
        variant="temporary"
        open={mobileOpen}
        onClose={onMobileClose}
        ModalProps={{ keepMounted: true }}
        sx={{
          display: { xs: 'block', md: 'none' },
          '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
        }}
      >
        {drawerContent}
      </Drawer>
      <Drawer
        variant="permanent"
        open
        sx={{
          display: { xs: 'none', md: 'block' },
          '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
        }}
      >
        {drawerContent}
      </Drawer>
    </Box>
  );
};

export default Sidebar; 